import $ from "jquery";

const $sideNav = $(".nav--sidebar-nav");
const $currentBranch = $("[class^=currentbranch]");

if ($sideNav.length) {
	// console.log($sideNav); // this is our sidebar element
	// console.log($currentBranch.length); // length of currentbranch elements
	// console.log($currentBranch[$currentBranch.length - 1]); // the last one of these
	let lastCurrent = $currentBranch[$currentBranch.length - 1];

	$(lastCurrent).parent("li").addClass("nav--sidebar-nav_active");
}
